<div class="layout {{ pagesService.sideMenuSignal() ? 'has-sidebar--left': '' }} animated fadeIn">
  @if(pagesService.sideMenuSignal()) {
  <aside class="sidebar">

    <nav class="sidebar-nav" [class.height-sidebar-nav]="!hasGlobalMessages()"
      [class.height-sidebar-nav-global-message]="hasGlobalMessages()">
      @for (item of pagesService.sideMenuSignal(); track $index) {
      <div class="nav-item">
        <a class="nav-item-title" [routerLink]="item.link" routerLinkActive="active">
          {{item.title}}
        </a>
      </div>
      }
    </nav>

  </aside>
  }
  <main class="content" id="scroll-to-top-ref">
    @if (pagesService.showBreadcrumb()) {
    <div class="content__breadcrumb">
      <ol class="breadcrumb">
        <li><span class="breadcrumb-item" (click)="goBack()">
            <div class="icon-back"></div>
            Back
          </span></li>
      </ol>
    </div>
  }
    <div class="content__main{{pagesService.showBreadcrumb() ? '' : '--no-padding'}}">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<app-footer></app-footer>
